define("shared/helpers/format-datetime", ["exports", "@ember/component/helper", "@ember/service", "later/utils/constants"], function (_exports, _helper, _service, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/service",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let formatDateTime = (_class = class formatDateTime extends _helper.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "locale", _descriptor, this);
    }

    compute(_ref) {
      let [date, format] = _ref;
      let displayFormat;

      switch (format) {
        case 'short':
          displayFormat = _constants.DATE_LENGTH.SHORT;
          break;

        case 'medium':
          displayFormat = _constants.DATE_LENGTH.MEDIUM;
          break;

        case 'long':
          displayFormat = _constants.DATE_LENGTH.LONG;
          break;

        default:
          displayFormat = _constants.DATE_LENGTH.MEDIUM;
      }

      return this.locale.formatDateTime(date, displayFormat);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = formatDateTime;
});